import React, { useContext } from "react";
import { Flex, Layout } from "antd";
import {
    HeaderComp,
    TwoColumnsTextLeft,
    CarouselComp,
    FooterComp
} from "../../../components";
import { LangContext } from "../../../utils/LanguageProvider";

const { Header, Content, Footer } = Layout

const Payins = () => {
    const { lang } = useContext(LangContext);
    return (
        <>
            <Header>
                <div className="header-container">
                    <HeaderComp />
                </div>
            </Header>
            <div className="full-container">
                <Flex vertical style={{ maxWidth: '1400px', width: '100%' }}>
                    <Content className="global-content">
                        <TwoColumnsTextLeft page={"payins"} section={"twocolumnstextleft-hero"} lang={lang} />
                        <TwoColumnsTextLeft page={"payins"} section={"twocolumnstextleft-accordion"} comp={'Accordion'} lang={lang} />             
                        <TwoColumnsTextLeft page={"payins"} section={"twocolumnstextleft-handle-accordion"} comp={'Accordion'} lang={lang} />             
                        <CarouselComp page={"payins"} section={"carousell"} type={'smallCards'} lang={lang} />
                    
                    </Content>
                </Flex>
            </div>
            <Footer>
                <FooterComp page={'payins'} lang={lang} />
            </Footer>
        </>
    );
};

export default Payins;
